import { render, staticRenderFns } from "./newAssetsInfoYiXin.vue?vue&type=template&id=ddd6c54a&scoped=true&"
import script from "./newAssetsInfoYiXin.vue?vue&type=script&lang=js&"
export * from "./newAssetsInfoYiXin.vue?vue&type=script&lang=js&"
import style0 from "./newAssetsInfoYiXin.vue?vue&type=style&index=0&id=ddd6c54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd6c54a",
  null
  
)

export default component.exports